import React from "react";
import { Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";

const About = () => {
  return (
    <div>
      <h1>AboutUs</h1>
      <Container>
        <Row className="mt-4" style={{ fontSize: "18px" }}>
          We are here for the children and parents. In the modern world, we
          can't do anything without computers, tablets, and phones and our
          mission is to start teaching children how to use these modern devices.
          They can add their wishes in the section Letter to Santa and parents
          can see them.
        </Row>
        <Row className="mt-4" style={{ fontSize: "18px" }}>
          We believe that children and parents who still believe in Santa Claus
          and want to carry this tradition as long as possible will find
          something useful on this site.
        </Row>
        <Row className="mt-4" style={{ fontSize: "18px" }}>
          They can also find games in their free time. They can choose between
          four games. Hangman, Minesweeper, Memory Game, and Tic Tac Toe.
        </Row>
      </Container>
      <Container className="mt-5 mb-5">
        <Row className="d-flex justify-content-center">
          <Card style={{ width: "13rem" }} className="me-3 mt-3">
            <Card.Img
              variant="top"
              className="mx-4 mt-4"
              src={require("../../images/adis.png")}
              style={{ height: 130, width: 130, borderRadius: "50%" }}
            />
            <Card.Body>
              <Card.Title style={{ color: "black" }}>Adis Tipura</Card.Title>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Engineering Manager
              </Card.Text>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Paragon student.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: "13rem" }} className="me-3 mt-3">
            <Card.Img
              variant="top"
              className="mx-4 mt-4"
              src={require("../../images/neven.png")}
              style={{ height: 130, width: 130, borderRadius: "50%" }}
            />
            <Card.Body>
              <Card.Title style={{ color: "black" }}>
                Neven Kusturica
              </Card.Title>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Product Manager
              </Card.Text>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Paragon student.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: "13rem" }} className="me-3 mt-3">
            <Card.Img
              variant="top"
              className="mx-4 mt-4"
              src={require("../../images/emir.png")}
              style={{ height: 130, width: 130, borderRadius: "50%" }}
            />
            <Card.Body>
              <Card.Title style={{ color: "black" }}>Emir Dedic</Card.Title>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Frontend Developer
              </Card.Text>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Paragon student.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: "13rem" }} className="me-3 mt-3">
            <Card.Img
              variant="top"
              className="mx-4 mt-4"
              src={require("../../images/milos.png")}
              style={{ height: 130, width: 130, borderRadius: "50%" }}
            />
            <Card.Body>
              <Card.Title style={{ color: "black" }}>Milos Ivanis</Card.Title>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Backend Developer
              </Card.Text>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Paragon student.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: "13rem" }} className="me-3 mt-3">
            <Card.Img
              variant="top"
              className="mx-4 mt-4"
              src={require("../../images/gorazd.png")}
              style={{ height: 130, width: 130, borderRadius: "50%" }}
            />
            <Card.Body>
              <Card.Title style={{ color: "black" }}>Gorazd Tezak</Card.Title>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Product Designer
              </Card.Text>
              <Card.Text style={{ color: "black", fontSize: "15px" }}>
                Paragon student.
              </Card.Text>
            </Card.Body>
          </Card>
        </Row>
      </Container>
    </div>
  );
};

export default About;
